import { Signature } from '../signature.js';
const signatureLayout = [
    { name: "r", binary: "uint", size: 32 },
    { name: "s", binary: "uint", size: 32 },
    { name: "v", binary: "uint", size: 1 },
];
export const signatureItem = {
    binary: "bytes",
    layout: signatureLayout,
    custom: {
        to: (val) => new Signature(val.r, val.s, val.v),
        from: (val) => ({ r: val.r, s: val.s, v: val.v }),
    },
};
//# sourceMappingURL=signature.js.map